<template>
    <div class="c-calendar-filter">
        <label id="c-event__select" class="c-calendar-filter__title">By event</label>
        <v-select aria-labelledby="c-event__select" :options="options" @input="chosenValue" v-model="selected"></v-select>
    </div>
</template>

<script>
    import axios from 'axios'
    import vSelect from 'vue-select'
    import {EventBus} from "../event-bus"

    export default {
        name: "ProductionFilter",
        components: {
            'v-select': vSelect
        },
        data() {
            return {
                selected: '',
                options: [],
                defaultValue: 'All Events',
            }
        },
        mounted() {
            this.fetchValues();
            this.selected = this.defaultValue;
            EventBus.$on('clearFilters', this.resetFilter)
        },
        methods: {
            chosenValue(item) {
                EventBus.$emit('updateEventFilters', 'event', item.value)
            },
            fetchValues() {
                axios.get(window.ajax.url, {
                    params: {
                        action: 'basethemeCalendarEventFilterRequest',
                    }
                }).then((response) => {
                    this.options = response.data.events
                }).catch(function (error) {
                    console.log(error)
                })
            },
            resetFilter() {
                this.selected = this.defaultValue;
            }
        }
    }
</script>

<style>
    @import '~vue-select/dist/vue-select.css';
</style>
